export default __webpack_public_path__ + "static/media/blogger.75f347c0.jpg";